import translations, { ICombinedTranslations } from '../translations';

export const getLoanPurposeLabels = (locale: keyof ICombinedTranslations) =>
  translations[locale].components.loanPurpose || translations['en-SE'].components.loanPurpose;

export const getCardPurposeLabels = (locale: keyof ICombinedTranslations) =>
  translations[locale].components.cardPurpose || translations['en-SE'].components.cardPurpose;

export const getMonthlyTurnoverOptions = (locale: keyof ICombinedTranslations) =>
  translations[locale].components.turnover || translations['en-SE'].components.turnover;

export const isOfType = <T>(
  varToBeChecked: any,
  propertyToCheckFor: keyof T
): varToBeChecked is T => (varToBeChecked as T)[propertyToCheckFor] !== undefined;

export const getDefaultLabelName = (locale: keyof ICombinedTranslations, componentName: string) => {
  try {
    return (
      translations[locale].components[componentName] || translations[locale].components.default
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      `Error in getDefaultLabelName. Tried to access the default label name with:\n Locale: ${locale}\n Component Name: ${componentName}\nError was this:`,
      error
    );
    return (
      translations['en-SE'].components[componentName] || translations['en-SE'].components.default
    );
  }
};
